import Siema from 'siema';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Grid, Button, Backdrop } from '@mui/material';

const styles = {
  button: {
    position: 'absolute',
    zIndex: 999,
    top: 0,
    height: '100%',
    width: '1em',
    minWidth: 'unset',
    padding: 0,
    background: '#ffffffcc',
    borderRadius: 0,
    fontSize: '1.5em',
  },
  cleanButton: {
    padding: 0,
    border: 'none',
    background: 'white',
    cursor: 'pointer',
  },
  fullScreenImg: {
    maxHeight: '85vh',
    maxWidth: '85vw',
    objectFit: 'contain',
  },
};

function PhotosCarousel({ urls, height }) {
  const [siema, setSiema] = useState(null);
  const [selectedUrl, setSelectedUrl] = useState('');

  useEffect(() => {
    setSiema(new Siema({ loop: urls.length > 1 }));
  }, []);

  const onNextClick = () => {
    siema.next();
  };

  const onPrevClick = () => {
    siema.prev();
  };

  return (
    <Grid style={{ position: 'relative' }}>
      <Backdrop
        open={!!selectedUrl}
        onClick={() => setSelectedUrl('')}
        style={{ backgroundColor: '#000000cc', zIndex: 1000 }}
      >
        <Grid container justifyContent="center" alignItems="center">
          {selectedUrl && (
            <img
              src={selectedUrl}
              alt="scooter"
              style={styles.fullScreenImg}
            />
          )}
        </Grid>
      </Backdrop>
      {urls.length > 1 && (
        <Button
          style={{ ...styles.button, left: 0 }}
          onClick={onPrevClick}
        >
          ❮
        </Button>
      )}
      <div className="siema">
        {urls.map((url) => (
          <Grid
            key={url}
            container
            justifyContent="center"
            alignItems="center"
            style={{ height }}
          >
            <button style={styles.cleanButton} onClick={() => setSelectedUrl(url)}>
              <img
                src={url}
                alt="scooter"
                style={{ maxHeight: height, maxWidth: '100%', objectFit: 'contain' }}
              />
            </button>
          </Grid>
        ))}
      </div>
      {urls.length > 1 && (
        <Button
          style={{ ...styles.button, right: 0 }}
          onClick={onNextClick}
        >
          ❯
        </Button>
      )}
    </Grid>
  );
}

PhotosCarousel.defaultProps = {
  urls: [],
  height: '100%',
};
PhotosCarousel.propTypes = {
  urls: PropTypes.arrayOf(PropTypes.string),
  height: PropTypes.string,
};

export default PhotosCarousel;
